import { render } from "./LoadingDialog.vue?vue&type=template&id=40f939f1&ts=true"
import script from "./LoadingDialog.vue?vue&type=script&lang=ts"
export * from "./LoadingDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__